import api from "../lib/axios";

export const getZoneData = async (eventId, token) => {
  const res = await api.get(`/zone/getAllZonesByEventsId?event_id=${eventId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },

    validateStatus: () => true,
  });
  return res;
};

export const getAllZonesByEventsId = async (eventId) => {
  const res = await api.get(`/zone/getAllZonesByEventsId`, {
    params: { event_id: eventId },
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const updateZoneAccessForUser = async (submissionId, zoneData, token) => {
  const res = await api.put(
    `/zone/updateZoneAccessForUser/${encodeURIComponent(submissionId)}`,
    { zoneData },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const getHalls = async (eventId, token, search = "") => {
  const params = { event_id: eventId };
  if (search && String(search).trim()) {
    params.search = String(search).trim();
  }
  const res = await api.get(`/zone/getHallByEventsId`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getTicketsForZone = async (eventId, token) => {
  const res = await api.get(`/zone/getTicketsForZone?event_id=${encodeURIComponent(String(eventId))}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const createHall = async ({ name, address, event_id }, token) => {
  const res = await api.post(`/zone/addHall`, { name, address, event_id }, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllZones = async (eventId, token, search = "") => {
  const params = { event_id: eventId };
  if (search && String(search).trim()) {
    params.search = String(search).trim();
  }
  const res = await api.get(`/zone/getAllZonesByEventsId`, {
    params,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const updateZone = async (zoneId, eventId, body, token) => {
  const res = await api.put(`/zone/updateZone/${zoneId}?event_id=${encodeURIComponent(String(eventId))}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const createZone = async (eventId, body, token) => {
  const res = await api.post(`/zone/createZone/${eventId}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const deleteZone = async (zoneId, eventId, token) => {
  const res = await api.delete(`/zone/deleteZone/${zoneId}?event_id=${encodeURIComponent(String(eventId))}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllZonesByEventsId2 = async (eventId) => {
  const res = await api.get(`/zone/getAllZonesByEventsId?event_id=${eventId}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const updateHall = async (hallId, body, token) => {
  const res = await api.put(`/zone/updateHall/${hallId}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const deleteHall = async (hallId, token) => {
  const res = await api.delete(`/zone/deleteHall/${hallId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};
